import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import {
  CSCMollieApplePay,
  TrydentMollieApplePayData
} from 'components/ordering/checkout/payment-methods/methods/mollie/apple-pay/mollie-apple-pay.js'
import { dependencyContainer } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import {
  APPLE_PAY_AVAILABILITY_CHECKER,
  ApplePayAvailabilityChecker
} from 'components/ordering/checkout/payment-methods/methods/mollie/apple-pay/apple-pay-availability-checker.js'


type TrydentMollieGenericResponse = {
  custom_description: string,
  mollie_data: TrydentMollieApplePayData & { id: 'applepay' }
}

export const parseMollieApplePay = (value: unknown, selectedPaymentMethod: string): CSCMollieApplePay | typeof CouldNotParse => {
  if (is<TrydentMollieGenericResponse>(value)) {
    const applePayChecker = dependencyContainer.getDependency(APPLE_PAY_AVAILABILITY_CHECKER) as ApplePayAvailabilityChecker
    if (!applePayChecker.canMakeApplePayments()) {
      return CouldNotParse
    }
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieApplePay(
      value.mollie_data,
      state,
      value.custom_description,
    )
  }
  return CouldNotParse
}
